import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";

export interface ProductSpecificationOption {
  name: string;
  value: string;
  type?: string;
}

export interface ProductSpecificationsProps {
  options: ProductSpecificationOption[];
  className?: string;
}

const ProductSpecifications: React.FC<ProductSpecificationsProps> = ({ options, className }) => {
  const { t } = useTranslation();

  if (!options || options.length === 0) return null;

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.title}>{t("product-specifications.title", "Specifications")}</div>
      <ul className={styles.list}>
        {options.map((option, idx) => (
          <li className={styles.item} key={idx}>
            <span className={styles.name}>{option.name}</span>
            <span className={styles.value}>{option.value} {option.type}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProductSpecifications;
